import * as React from 'react';
import { CheckboxFilter } from '../../Filter/CheckboxFilter';
import { RadioFilter } from '../../Filter/RadioFilter';
import { Trans } from '../../Trans';
import { AbstractFilterSectionView, FilterSectionViewProps } from '../AbstractFilterSectionView';
import { FilterInfo } from '../FilterInfo';

interface FilterViewProps extends FilterSectionViewProps {
}

export class MaterialSensorFilterView extends AbstractFilterSectionView<FilterViewProps> {
    public render() {
        return <div className="pf-filter-container">
            <div className="pf-filter-section">
                <div className="row">
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Materialeigenschaften</Trans></div>
                        <CheckboxFilter filter={this.getFilter('@parent.Eignungsliste_fuer_Materialien')}
                                        options={this.collect('@parent.Eignungsliste_fuer_Materialien').localeSort()}
                                        onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Erfassungsbreite</Trans></div>
                        <RadioFilter filter={this.getFilter('@parent.Erfassungsbreite')}
                                     options={this.collectAvailable('@parent.Erfassungsbreite')}
                                     onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Gabelbreite</Trans></div>
                        <RadioFilter filter={this.getFilter('Gabelbreite')}
                                     options={this.collectAvailable('Gabelbreite')}
                                     onChange={this.handleChange}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Auflösung</Trans></div>
                        <RadioFilter filter={this.getFilter('@parent.Aufloesung')}
                                     options={this.collectAvailable('@parent.Aufloesung')}
                                     onChange={this.handleChange}/>
                    </div>
                </div>
            </div>
            <FilterInfo {...this.props}/>
        </div>;
    }
}
